<template>
  <div v-if="customer.avatar" class="mr-3">
    <img v-bind:src="customer.avatar" v-bind:alt="customer.name" class="rounded-full object-cover max-w-none" :class="sizeStyles" v-tippy>
    <tippy>{{ customer.name }}</tippy>
  </div>
  <div v-else class="flex-initial mr-3">
    <svg class="bg-gray-100 rounded-full p-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="48px" height="48px" viewBox="0 0 24 24" version="1.1"  v-tippy>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <polygon points="0 0 24 0 24 24 0 24"/>
          <path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3"/>
          <path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fill-rule="nonzero"/>
      </g>
    </svg>
    <tippy>{{ customer.name }}</tippy>
  </div>
</template>

<script>

export default {
  name: 'AvatarWidget',
  props: ['customer', 'size'],
  computed: {
    sizeStyles() {
      if (this.size) {
        return this.size;
      } else {
        return 'h-12 w-12';
      }
    }
  }
}
</script>
